module.exports = __webpack_public_path__ + "assets/modernhealth.b925168d.png";